import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { PriorActivityDetailsType } from "../types";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
function DetailsComponent({
  data,
}: {
  data: PriorActivityDetailsType[] | null;
}) {

  return (
    <div className="p-3 flex flex-col gap-5 w-full h-full overflow-y-scroll">

      <div className="flex justify-between gap-2">
        <Typography variant="h6">Activity details</Typography>
      </div>

      <div className="flex flex-row justify-start gap-5 w-full">
        <div className="border-2">
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>CPT code</strong>
                </TableCell>
                <TableCell>
                  <strong>Insurance amount</strong>
                </TableCell>
                <TableCell>
                  <strong>Quantity </strong>
                </TableCell>
                <TableCell>
                  <strong>Net Amount</strong>
                </TableCell>
                <TableCell>
                  <strong>Approved Amount</strong>
                </TableCell>
                <TableCell>
                  <strong>Denial Code</strong>
                </TableCell>
                <TableCell>
                  <strong>Description </strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <CustomTableBody
             alert={"No data"}
             dataLoading={false}
             isData={Boolean(data?.length)}
             totalSpan={{row:5,col:7}}
            >
              {data?.map((row, i) => (
                <TableRow
                  key={`activityDetails${i}`}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                                 <TableCell>{row?.cptCode}</TableCell>
                                 <TableCell>{row?.insAmount}</TableCell>
                                 <TableCell>{row?.remitQty}</TableCell>
                                 <TableCell>{row?.remitNetAmount}</TableCell>
                                 <TableCell>{row?.remitPayAmt}</TableCell>
                                 <TableCell>{row?.denialCode}</TableCell>
                                 <TableCell>{row?.comments}</TableCell>
                </TableRow>
              ))}
            </CustomTableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default DetailsComponent;
